import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { useAppContext } from "../../context/AppContext";
import { googleLogout } from '@react-oauth/google';
// import GlobalLoader from "../../components/GlobalLoader";

function Logout(){
    const history = useNavigate();
    const { updateTrialInfo, resetOnboarding } = useAppContext();
    useEffect(()=>{
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        localStorage.removeItem("authToken"); 
        localStorage.removeItem("expiry"); 
        localStorage.removeItem("refresh");
        localStorage.removeItem("userName");
        localStorage.removeItem("userId");
        localStorage.removeItem("reset");
        googleLogout();
        resetOnboarding();
        updateTrialInfo({ isTrial: null, daysRemaining: 0, trialEndDate: null })
        setTimeout(()=>{ history('/login'); }, 1000)
    },[])

    return(
        <div className="page-content">
            {/* <GlobalLoader isLoading={true}/> */}
            <Container fluid>
                <Row>
                    <Col>
                        <p>Safely logging you out of your account. Please Wait...</p>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default Logout;